import moment from 'moment';

export const checkDateFieldValueIsValid = (date: Date | null) => {
  const isDateInvalid = date && !moment(date).isValid();

  const isDateBeyondWidgetUpperBound = (date?.getFullYear() ?? 2000) > 2099;

  const isDateBeyondWidgetLowerBound = (date?.getFullYear() ?? 2000) < 1900;

  return !(isDateInvalid || isDateBeyondWidgetUpperBound || isDateBeyondWidgetLowerBound);
};
